import React from 'react';

// COMPONENTS
import Features from '@/components/Accordions/Features';

const RightSection = () => {
  return (
    <div className="welcome__right">
      <Features />
    </div>
  );
};

export default React.memo(RightSection);
